import React from "react";
import axios from "axios";
import {
  CardContent,
  Typography,
  Button,
  TextField,
  Container,
} from "@material-ui/core";

class SignIn extends React.Component {
  state = {
    email: "",
    password: "",
  };

  handleSignIn = async () => {
    const { email, password } = this.state;
    const doc = await axios.post("/api/literacy/tutor/login", {
      email,
      password
    });
    if (doc.data.msg === true) window.location = "/literacy/";
  };

  render() {
    const { email, password } = this.state;
    return (
      <div style={{ position: "relative", top: 70 }}>
        <Container className="text-center">
          <CardContent>
            <Typography color="textSecondary" style={{ fontSize: 40 }}>
              Tutor Signin
            </Typography>
            <TextField
              id="standard-basic tutor-email"
              label="Email"
              style={{ width: 300, marginTop: 10 }}
              value={email}
              onChange={(e) => this.setState({ email: e.target.value })}
            />
            <br />
            <TextField
              id="standard-basic tutor-password"
              label="Password"
              type="password"
              style={{ width: 300, marginTop: 10 }}
              value={password}
              onChange={(e) => this.setState({ password: e.target.value })}
            />
            <br />
            <Button
              variant="contained"
              style={{
                width: 300,
                height: 50,
                marginTop: 10,
                color: "white", backgroundColor: "#107896"
              }}
              onClick={this.handleSignIn}
            >
              Sign In
            </Button>
          </CardContent>
        </Container>
      </div>
    );
  }
}

export default SignIn;
